var map = {
	"./canvas/blocks/custom/buttons/admin/BlockPanel.vue": 39101,
	"./canvas/blocks/custom/footer/admin/BlockPanel.vue": 87343,
	"./canvas/blocks/custom/gallery/admin/BlockPanel.vue": 32014,
	"./canvas/blocks/custom/header/admin/BlockPanel.vue": 39133,
	"./canvas/blocks/custom/header/block.js": 26329,
	"./canvas/blocks/custom/navbar/admin/BlockPanel.vue": 33894,
	"./canvas/blocks/custom/photoWithText/admin/BlockPanel.vue": 49199,
	"./canvas/blocks/custom/team/admin/BlockPanel.vue": 83109,
	"./canvas/blocks/modules/mailchimp/admin/BlockPanel.vue": 30076,
	"./canvas/blocks/sky/accordion/admin/BlockPanel.vue": 90904,
	"./canvas/blocks/sky/callToActionAlfa/admin/BlockPanel.vue": 55041,
	"./canvas/blocks/sky/callToActionBravo/admin/BlockPanel.vue": 70307,
	"./canvas/blocks/sky/callToActionCharlie/admin/BlockPanel.vue": 24321,
	"./canvas/blocks/sky/callToActionCharlie/block.js": 27809,
	"./canvas/blocks/sky/code/admin/BlockPanel.vue": 94779,
	"./canvas/blocks/sky/contentAlfa/admin/BlockPanel.vue": 41935,
	"./canvas/blocks/sky/contentBlog/admin/BlockPanel.vue": 33599,
	"./canvas/blocks/sky/contentBlog/admin/LoopItemPanel.vue": 55871,
	"./canvas/blocks/sky/contentBlog/block.js": 11291,
	"./canvas/blocks/sky/contentBravo/admin/BlockPanel.vue": 46617,
	"./canvas/blocks/sky/contentBravoReversed/admin/BlockPanel.vue": 97055,
	"./canvas/blocks/sky/contentCard/admin/BlockPanel.vue": 1957,
	"./canvas/blocks/sky/contentCard/admin/LoopItemPanel.vue": 47217,
	"./canvas/blocks/sky/contentCard/admin/LoopPanel.vue": 90894,
	"./canvas/blocks/sky/contentCardThumbnail/admin/BlockPanel.vue": 93747,
	"./canvas/blocks/sky/contentCardThumbnail/admin/LoopItemPanel.vue": 93099,
	"./canvas/blocks/sky/contentDelta/admin/BlockPanel.vue": 92431,
	"./canvas/blocks/sky/contentEcho/admin/BlockPanel.vue": 27330,
	"./canvas/blocks/sky/contentStats/admin/BlockPanel.vue": 79458,
	"./canvas/blocks/sky/contentStats/admin/LoopItemPanel.vue": 49544,
	"./canvas/blocks/sky/contentStats/admin/LoopPanel.vue": 40603,
	"./canvas/blocks/sky/footerAlfa/admin/BlockPanel.vue": 1257,
	"./canvas/blocks/sky/footerBravo/admin/BlockPanel.vue": 20731,
	"./canvas/blocks/sky/footerCharlie/admin/BlockPanel.vue": 79481,
	"./canvas/blocks/sky/formAlfa/admin/BlockPanel.vue": 32240,
	"./canvas/blocks/sky/headerAlfa/admin/BlockPanel.vue": 98383,
	"./canvas/blocks/sky/headerAlfa/block.js": 96977,
	"./canvas/blocks/sky/headerBravo/admin/BlockPanel.vue": 78393,
	"./canvas/blocks/sky/headerBravo/block.js": 72837,
	"./canvas/blocks/sky/headerCharlie/admin/BlockPanel.vue": 51791,
	"./canvas/blocks/sky/headerCharlie/block.js": 10979,
	"./canvas/blocks/sky/icons/admin/BlockPanel.vue": 57940,
	"./canvas/blocks/sky/icons/admin/LoopItemPanel.vue": 76478,
	"./canvas/blocks/sky/icons/admin/LoopPanel.vue": 92305,
	"./canvas/blocks/sky/price/admin/BlockPanel.vue": 83307,
	"./canvas/blocks/sky/price/admin/LoopItemPanel.vue": 19219,
	"./canvas/blocks/sky/price/admin/LoopPanel.vue": 96072,
	"./canvas/blocks/sky/scrollUpAlfa/admin/BlockPanel.vue": 30314,
	"./canvas/blocks/sky/scrollUpAlfa/block.js": 13796,
	"./canvas/blocks/sky/sliderAlfa/admin/BlockPanel.vue": 44287,
	"./canvas/blocks/sky/sliderAlfa/admin/LoopItemPanel.vue": 99871,
	"./canvas/blocks/sky/sliderAlfa/block.js": 59101,
	"./canvas/blocks/sky/sliderBravo/admin/BlockPanel.vue": 73417,
	"./canvas/blocks/sky/sliderBravo/admin/LoopItemPanel.vue": 35501,
	"./canvas/blocks/sky/sliderBravo/block.js": 38537,
	"./vendor/canvas/canvas/blocks/utils/text/admin/ckEditorConfig.js": 537
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3078;